var _Circle, _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
function SvgFacebookDark(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 17.5,
    cy: 17.5,
    r: 17.06,
    fill: "#1d1c39"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M17.5.88c9.17 0 16.62 7.46 16.62 16.62S26.66 34.12 17.5 34.12.88 26.67.88 17.5 8.33.88 17.5.88m0-.88C7.88 0 0 7.88 0 17.5S7.88 35 17.5 35 35 27.12 35 17.5 27.12 0 17.5 0z",
    fill: "#e1087e"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M18.77 26v-8.04h2.68l.51-3.33h-3.19v-2.16c0-.91.45-1.8 1.87-1.8h1.45V7.84s-1.32-.22-2.58-.22c-2.63 0-4.35 1.59-4.35 4.48v2.53h-2.92v3.33h2.92V26h3.6z",
    fill: "#fff"
  })));
}
export default SvgFacebookDark;